/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_fp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do sprint weekends score differently?`)
};

const es_f1_fp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puntúan distinto los fines de semana de sprint?`)
};

const de_f1_fp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden Sprint-Wochenenden anders bewertet?`)
};

const nl_f1_fp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoren sprintweekenden anders?`)
};

const fr_f1_fp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les week-ends de sprint sont-ils notés différemment ?`)
};

const it_f1_fp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I weekend sprint vengono valutati diversamente?`)
};

const pt_br2_f1_fp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fins de semana de sprint pontuam diferente?`)
};

const pt_f1_fp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os fins de semana de sprint pontuam de forma diferente?`)
};

const ja_f1_fp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スプリント週末は得点方法が違いますか？`)
};

const zh_f1_fp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冲刺赛周末的计分方式不同吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_fp_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_fp_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_fp_faq4_q", locale)
	if (locale === "en") return en_f1_fp_faq4_q(inputs)
	if (locale === "es") return es_f1_fp_faq4_q(inputs)
	if (locale === "de") return de_f1_fp_faq4_q(inputs)
	if (locale === "nl") return nl_f1_fp_faq4_q(inputs)
	if (locale === "fr") return fr_f1_fp_faq4_q(inputs)
	if (locale === "it") return it_f1_fp_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_fp_faq4_q(inputs)
	if (locale === "pt") return pt_f1_fp_faq4_q(inputs)
	if (locale === "ja") return ja_f1_fp_faq4_q(inputs)
	return zh_f1_fp_faq4_q(inputs)
};